<template lang="pug">
  #app
    flash-message.flashpool(transitionName="flash")
    .progress-bar(v-show="loading")
      progress-bar
    div(v-if="isLoggedIn")
      sidebar
      div.page#page(:class="{'page--full': isFullView, 'page--collapsed': !isFullView}")
        navbar(:key="$route.fullPath")
        .content(:class="{'loading': loading}")
          .content__body
            .box
              .box__content
                template(v-if="isAdmin && initialized")
                  template(v-if="!$route.meta.disableForAdmin")
                    router-view(
                      name="default"
                      :key="$route.fullPath"
                    )
                  template(v-else)
                    page-disabled-for-admin
                template(v-else)
                  template(v-if="initialized && !$route.meta.disableOnFreePlan")
                    router-view(
                      name="default"
                      :key="$route.fullPath"
                    )
                  template(v-else)
                    template(v-if="initialized && isFullFeatured")
                      router-view(
                        name="default"
                        :key="$route.fullPath"
                      )
                    template(v-else)
                      page-unpaid-disabled
        footerbar
    div(v-else).page#page
      .content.content--auth
        .auth-box
          .box__content
            router-view(
              name="auth"
            )
</template>

<script>
import { mapState } from 'vuex';
import Navbar from '@/components/Navbar/Navbar.vue';
import Sidebar from '@/components/Sidebar/Sidebar.vue';
import Footerbar from '@/components/Footerbar/Footerbar.vue';
import ProgressBar from '@/components/ProgressBar/ProgressBar.vue';
import PageUnpaidDisabled from '@/components/ui/errors/PageUnpaidDisabled/PageUnpaidDisabled.vue';
import PageDisabledForAdmin from '@/components/ui/errors/PageDisabledForAdmin/PageDisabledForAdmin.vue';

export default {
  mounted() {
    this.addYandexAnalytics();
    this.addGoogleAnalytics();
    this.addVkAnalytics();
    this.addNoscripts();
    this.addJivosite();
  },

  data() {
    return {
      openTutorialStep: false
    };
  },

  components: {
    Navbar,
    Sidebar,
    Footerbar,
    ProgressBar,
    PageUnpaidDisabled,
    PageDisabledForAdmin
  },

  computed: {
    ...mapState({
      loading: state => state.global.loading,
      initialized: state => state.global.initialized,
      isFullFeatured: state => state.billing.isFullFeatured,
      isAdmin: state => state.user.profile.isAdmin
    }),

    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    isFullView() {
      return this.$store.state.navigation.fullView;
    },

    routeAvailableOnFreePlan() {
      return true;
    }
  },

  methods: {
    addYandexAnalytics() {
      (function(m, e, t, r, i, k, a) {
        m[i] =
          m[i] ||
          function() {
            (m[i].a = m[i].a || []).push(arguments);
          };
        // eslint-disable-next-line no-param-reassign
        m[i].l = 1 * new Date();
        // eslint-disable-next-line no-param-reassign
        k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a);
      })(
        window,
        document,
        'script',
        'https://mc.yandex.ru/metrika/tag.js',
        'ym'
      );
      ym(53389741, 'init', {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true
      });
    },

    addGoogleAnalytics() {
      let s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.googletagmanager.com/gtag/js?id=UA-138767966-1';
      s.onload = function() {
        window.dataLayer = window.dataLayer || [];

        function gtag() {
          dataLayer.push(arguments);
        }

        gtag('js', new Date());

        gtag('config', 'UA-138767966-1');
      };
      document.head.appendChild(s);
    },

    addVkAnalytics() {
      !function () {
        let t = document.createElement('script');
        t.type = 'text/javascript';
        t.async = !0;
        t.src = 'https://vk.com/js/api/openapi.js?160';
        t.onload = function() {
          VK.Retargeting.Init('VK-RTRG-367795-ftplS');
          VK.Retargeting.Hit();
        };
        document.head.appendChild(t);
      }();
    },

    addNoscripts() {
      let ns = document.createElement('noscript');
      let yandex = document.createElement('img');
      yandex.src = 'https://mc.yandex.ru/watch/53389741';
      yandex.style = 'position:absolute; left:-9999px;';
      let vk = document.createElement('img');
      vk.src = 'https://vk.com/rtrg?p=VK-RTRG-367795-ftplS';
      vk.style = 'position:absolute; left:-9999px;';
      ns.appendChild(yandex);
      ns.appendChild(vk);
      document.head.appendChild(ns);
    },

    addJivosite() {
      let s = document.createElement('script');
      s.async = true;
      s.src = '//code-ya.jivosite.com/widget/zxmR1E3lTJ';
      document.head.appendChild(s);
    }
  }
};
</script>

<style lang="scss">
@import '~@/assets/scss/core.scss';

#app {
  position: relative;
  width: 100%;
  overflow-x: hidden;
}

.page {
  transition: margin $nav-collapse-duration $base-timing;

  &--full {
    margin-left: $logo-expanded-width;
  }

  &--collapsed {
    margin-left: $logo-collapsed-width;
  }
}

.content {
  transition: opacity 100ms ease-in-out;
  &.loading {
    opacity: 0.25;
  }
}

.flashpool {
  position: fixed;
  top: 20px;
  right: 20px;
  max-height: 400px;
  width: 260px;
  perspective: 400px;
  z-index: 10000;
}

.flashpool .flash__message {
  width: 260px;
  transition: all 500ms;
  display: flex;
  font-size: 13px;
  line-height: 130%;
}

.flash-enter,
.flash-leave-to {
  opacity: 0;
  -webkit-transform: rotateX(-30deg) scale(0.88) translateY(-30px);
  transform: rotateX(-30deg) scale(0.88) translateY(-30px);
}

.flash-leave-active {
  position: absolute;
}

.progress-bar {
  position: fixed;
  z-index: 1999;
  top: 0;
  left: 0;
  width: 100%;
}

.auth-box {
  @extend %box;
  width: auto;
  background-color: #fde0b7;
  margin-bottom: 0;
}
</style>
